import { ScreenRotationLockIcon } from './ScreenRotationLockIcon';

/**
 * author: Google
 * id 0C15E49D-5D29-4A3D-803B-0B9695295E04
 * name screen-rotation-lock
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/screen-rotation-lock.svg
 * tags
 * - Lock 
 */
export const ScreenLockRotationIcon = ScreenRotationLockIcon;
export default ScreenLockRotationIcon